import React from "react";
import { Link } from "react-router-dom";
import CompanyForm from "./Companyform"; // Adjust the import path as necessary
import './onioncomp.css'; // Adjust the CSS file path as necessary

const TempoInstrumentsComp = () => {
    // Company data for Tempo Instruments Pvt Ltd
    const companyData = {
        name: "Tilak Mishra",
        email: "tilak.mishra@tempo.net.in",
        mobileNumber: "8657914563",
        companyName: "Tempo Instruments Pvt Ltd",
        productOrService: "Electric Heating Tape, Electric Heating Cord, Lab Hot Air Oven, Lab Equipment",
        productDescribe: "Tempo Instruments Pvt Ltd specializes in high-quality laboratory equipment such as electric heating tapes, cords, and lab hot air ovens, providing reliable solutions for scientific applications.",
        businessType: "Manufacturer & Supplier",
        mainProducts: "Electric Heating Tape, Electric Heating Cord, Lab Hot Air Oven",
        logoUrl: "/assets/electric1.jpeg", // Placeholder path to company logo image
    };

    return (
        <>
            <div className="container">
                <ol className="breadcrumb">
                    <li style={{ display: 'flex', justifyContent: 'center', margin: '5px 30px' }} className="breadcrumb-item">
                        <Link to={'/'}>Home</Link>
                    </li>
                    <li style={{ display: 'flex', justifyContent: 'center', margin: '5px -25px' }} >/</li>
                    <li style={{ display: 'flex', justifyContent: 'center', margin: '5px 30px' }} className="breadcrumb-item active">Search</li>
                </ol>
            </div>
            <div className="b2b-page">
                <div className="content-left">
                    {/* Display Tempo Instruments Pvt Ltd information */}
                    <div className="company-card">
                        <div className="company-header">
                            <div className="company-logo">
                                <img src={companyData.logoUrl} alt="Company Logo" />
                            </div>
                            <div className="company-details">
                                <h3>{companyData.companyName}</h3>
                                <p><strong>Description:</strong> {companyData.productDescribe}</p>

                                <div className="imp-btns">
                                    <button style={{ backgroundColor: '#4ee54e' }} className="main-btns">
                                        <Link to={'/register-buyer'}>Connect Now</Link>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <p><strong>Business Type:</strong> {companyData.businessType}</p>
                        <p><strong>Main Products:</strong> {companyData.mainProducts}</p>
                    </div>
                </div>
                <CompanyForm />
            </div>
        </>
    );
}

export default TempoInstrumentsComp;
